import { reactLocalStorage } from "reactjs-localstorage";
import useAuthStore from "store/authStore";
import useTokenStore from "store/tokenStore";
import { resolveSafeInternalPath } from "utils/intendedUrl";
import { withoutAuthUrl } from "utils/authModal";

/**
 * Persist a successful login or registration, then close auth on the current page.
 * An intended URL resumes a protected destination when required.
 *
 * @param {object} body - API response body (`{ data: { user, access_token, refresh_token } }`)
 * @param {object} options
 * @param {import("react-query").QueryClient} options.queryClient
 * @param {import("history").History} options.history
 * @param {string|null} [options.intended]
 */
export const persistAuthSession = (body, { queryClient, history, intended = null }) => {
	const {
		storeUser,
		storeUserRoles,
		storeUserPermissions,
		storeUserObjectPermissions,
		storeRefreshToken,
		setSubscriptionStatus,
		setLogInStatusToTrue,
	} = useAuthStore.getState();

	const { storeAccessToken } = useTokenStore.getState();

	queryClient.clear();
	reactLocalStorage.clear();

	const user = body?.data?.user;

	storeUser(user);
	storeAccessToken(body?.data?.access_token);
	storeRefreshToken(body?.data?.refresh_token);
	storeUserRoles(user?.role_name);
	storeUserPermissions(user?.permission_names);
	storeUserObjectPermissions(user?.object_permissions);
	setLogInStatusToTrue();
	setSubscriptionStatus(user?.subscriptions?.length > 0 ? 1 : 0);
	const destination = resolveSafeInternalPath(intended);
	history.replace(destination || withoutAuthUrl(history.location));
};
